export default function SvgWifi() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M1 8.99977L3 10.9998C7.97 6.02977 16.03 6.02977 21 10.9998L23 8.99977C16.93 2.92977 7.08 2.92977 1 8.99977ZM9 16.9998L12 19.9998L15 16.9998C14.6064 16.6051 14.1388 16.292 13.624 16.0784C13.1092 15.8648 12.5574 15.7548 12 15.7548C11.4426 15.7548 10.8908 15.8648 10.376 16.0784C9.86117 16.292 9.39359 16.6051 9 16.9998ZM5 12.9998L7 14.9998C8.32646 13.6744 10.1249 12.9299 12 12.9299C13.8751 12.9299 15.6735 13.6744 17 14.9998L19 12.9998C15.14 9.13977 8.87 9.13977 5 12.9998Z"
        fill="black"
      />
    </svg>
  );
}
